import React from 'react'

function BombillaOutlined(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="18.51"
         height="18.098"
         viewBox="0 0 18.51 18.098"
         {...props}
      >
         <path
            fill={props.color}
            d="M20.008 8.082l-.473-1.028-1.028-.473 1.028-.473.473-1.028.473 1.028 1.028.473-1.028.473zM17.4 4.483l-.72-1.522-1.522-.72 1.522-.72L17.4 0l.72 1.522 1.522.72-1.522.72zM9.17 18.1a1.65 1.65 0 01-1.67-1.668h3.332A1.65 1.65 0 019.17 18.1zm-3.332-2.943v-1.234H12.5v1.234zm.1-2.489a6.748 6.748 0 01-2.149-2.211A5.725 5.725 0 013 7.466a5.93 5.93 0 011.83-4.34A5.93 5.93 0 019.17 1.3a5.93 5.93 0 014.339 1.83 5.93 5.93 0 011.83 4.339 5.783 5.783 0 01-.782 2.992 6.582 6.582 0 01-2.157 2.208zm.452-1.234h5.573a4.793 4.793 0 001.567-1.706 4.626 4.626 0 00.576-2.262 4.753 4.753 0 00-1.45-3.486A4.753 4.753 0 009.17 2.53a4.753 4.753 0 00-3.486 1.45 4.753 4.753 0 00-1.45 3.486 4.626 4.626 0 00.576 2.262 4.727 4.727 0 001.583 1.707zm2.78.001z"
            transform="translate(-3)"
         ></path>
      </svg>
   )
}

export default BombillaOutlined
